import { takeLatest, put, call } from 'redux-saga/effects';
import {
    fetchLeadersStart,
    fetchLeadersSuccess,
    fetchLeadersFail,
    fetchLeaderDetailsStart,
    fetchLeaderDetailsSuccess,
    fetchLeaderDetailsFail,
} from '../slices/leaderSlice';
import { getRequest } from '../../network';
import { LEADERS, LEADER_DETAIL } from '../apis';

function* fetchLeadersSaga(action) {
    try {
        const response = yield call(getRequest, LEADERS, action.payload || {});
        yield put(fetchLeadersSuccess(response));
    } catch (error) {
        yield put(fetchLeadersFail(error.response?.data?.message || error.message));
    }
}

function* fetchLeaderDetailsSaga(action) {
    try {
        const { leaderId } = action.payload;
        const path = LEADER_DETAIL.replace(':leaderId', leaderId);
        const response = yield call(getRequest, path);
        yield put(fetchLeaderDetailsSuccess(response));
    } catch (error) {
        yield put(fetchLeaderDetailsFail(error.response?.data?.message || error.message));
    }
}

export function* watchLeader() {
    yield takeLatest(fetchLeadersStart.type, fetchLeadersSaga);
    yield takeLatest(fetchLeaderDetailsStart.type, fetchLeaderDetailsSaga);
}
